import { useEffect, useState } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { auth, db } from '../../Firebase_Config/firebase';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { NavLink } from 'react-router-dom';
import './ProfilerLanding.css';
const GET_EMAIL = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });

  const [toastOpen, setToastOpen] = useState(false);
  const [toastSeverity, setToastSeverity] = useState('success');
  const [toastMessage, setToastMessage] = useState('');

  useEffect(() => {
    const fetchUserData = async () => {
      const user = auth.currentUser;
      if (!user) return;

      const userDocQuery = query(collection(db, 'users'), where('userId', '==', user.uid));
      const userDocSnapshot = await getDocs(userDocQuery);

      if (!userDocSnapshot.empty) {
        const userData = userDocSnapshot.docs[0].data();
        setFormData(prev => ({
          ...prev,
          name: userData.Name || '',
          email: userData.email || ''
        }));
      }
    };

    fetchUserData();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, message: e.target.value });
  };

  const showToast = (message, severity = 'success') => {
    setToastMessage(message);
    setToastSeverity(severity);
    setToastOpen(true);
  };

  const handleCloseToast = (_, reason) => {
    if (reason === 'clickaway') return;
    setToastOpen(false);
  };

  const onSubmit = async (event) => {
    event.preventDefault();

    const formDataToSend = {
      ...formData,
      access_key: "eeb7e415-06eb-495c-a9f8-075545b91e36"
    };

    const res = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify(formDataToSend)
    }).then((res) => res.json());

    if (res.success) {
      showToast("Email submitted successfully!", "success");
      setFormData(prev => ({ ...prev, message: '' }));
    } else {
      showToast("Failed to submit. Please try again.", "error");
    }
  };

  return (
    <div className="ContactContainer">
      <h1 className='helptitle'>Contact Form</h1>
      <br/>
      <div className='Hom-card-accent'/>
      
      <form onSubmit={onSubmit}>
        <textarea
          className='OtherInputs'
          name="message"
          placeholder="Write Your Message Here.."
          value={formData.message}
          onChange={handleChange}
        />
        <button className='SubmitInput' type="submit">Submit Form</button>
      </form>

      <Snackbar open={toastOpen} autoHideDuration={4000} onClose={handleCloseToast} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <MuiAlert onClose={handleCloseToast} severity={toastSeverity} sx={{ width: '100%' }} elevation={6} variant="filled">
          {toastMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
};


function ProfilerOpening() {

    const [showModal, setShowModal] = useState(true);
      const [hasPaidTrue, setHasPaidTrue] = useState(null);
      const [showContactModal, setShowContactModal] = useState(false);
    
      const getUserId = () => {
        const user = auth.currentUser;
        return user?.uid;
      };
    
      const fetchHasPaidTrue = async () => {
        try {
          const userId = getUserId();
          if (!userId) return;
    
          const userDocQuery = query(collection(db, 'users'), where('userId', '==', userId));
          const userDocSnapshot = await getDocs(userDocQuery);
    
          if (!userDocSnapshot.empty) {
            const userDocData = userDocSnapshot.docs[0].data();
            const getHasPaid = userDocData.HasPaid || false;
            setHasPaidTrue(getHasPaid);
          } else {
            console.log('User document not found');
            setHasPaidTrue(false); // default to false if not found
          }
        } catch (error) {
          console.error('Error fetching payment status:', error);
          setHasPaidTrue(false);
        }
      };
    
      useEffect(() => {
        fetchHasPaidTrue();
      });
    
      const isDisabled = hasPaidTrue === false;
      const handleContactClick = () => {
        setShowModal(false);
        setShowContactModal(true);
      };
    return (
        <div className='profilerBG'>
            {hasPaidTrue === false && showModal && (
              <div className="Ai-modal-overlay">
                <div className="paid-modal-content">
                  <button className="close-button" onClick={() => setShowModal(false)}>×</button>
                  <button className="contact-button" onClick={handleContactClick}>Contact Us To Get Access</button>
                </div>
              </div>
            )}

            {showContactModal && (
              <div className="Ai-modal-overlay">
                <div className="paid-modal-content contact">
                  <button className="close-button" onClick={() => setShowContactModal(false)}>×</button>
                  <GET_EMAIL />
                </div>
              </div>
            )}
            <div className='profilercontent'>
                <div className="profiler-container">
                    <div className='profiler-card-accent'/> 
                    <br/> 
                    {<img src="Rapid_Profile.png" alt="Logo" className='profiler-image' />}
                    <h2 className='headingcenter'>Where Data Integrity Meets AI Ethics</h2>
                    <div className='ProContainer'>
                        <div className='textContent'>
                            
                            <div className='Profiler2'>
                                <div className='profilercolumns'>
                                    <h2>What is RapidProfile?</h2>
                                    <p >RapidProfile automatically assesses dataset quality by performing in-depth analysis and validation. It generates comprehensive statistical summaries, detects missing or inconsistent values, and identifies anomalies, outliers, and potential schema mismatches. Additionally, it evaluates label quality in classification datasets, flagging mislabelled or ambiguous samples that could degrade model performance. By analysing data distributions, data types, and unexpected patterns, the tool provides actionable insights to improve dataset cleanliness and reliability. Its robust profiling capabilities help users ensure high-quality data for analytics, machine learning, and decision-making processes.</p>
                                </div>
                                <div className='profilercolumns'>
                                    <h2>Why RapidProfile?</h2>
                                    <p className='textContent'>RapidProfile accelerates the development of trustworthy AI systems by proactively addressing data quality risks that undermine model reliability. By automating critical quality checks, it prevents common failure points like biased training sets or flawed analytics while reducing manual validation efforts by up to 80%. RapidProfile's intelligent anomaly detection acts as an early warning system for data drift and integrity issues that could compromise production models. For compliance-focused industries, it provides auditable quality metrics that demonstrate adherence to data governance standards. Technical teams gain granular visibility into dataset health, enabling targeted cleaning where it matters most, while business stakeholders benefit from increased confidence in AI-driven insights. The solution ultimately bridges the gap between raw data and production-ready inputs, serving as a force multiplier for both data science productivity and model performance.</p>
                                </div>
                            </div>
                        </div>
                        <br/>
                        <div className='button-group'>
                          <NavLink 
                            to="/ContactUs" 
                          >
                            <button className='download-button' >Contact Us</button>
                          </NavLink>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ProfilerOpening;
